import { useEffect } from 'react';
import { useState } from 'react';

const Switch = (props) => {
    const [checked, setChecked] = useState(false)
    function switchClickHandler(params) {
        setChecked(!checked)
        setData(checked ? props.options[0].value : props.options[1].value)
    }

    function setData(value) {
        if (props.HasManyInputData) {
            props.HasManyInputData(props.index, props.HasManyKey, Number(value));
        } else {
            let object = props.inputData;
            object[props.item.key] = Number(value);
            props.setInputData(object);
        }
    }

    useEffect(() => {
        if (props.pageType === "edit") {
            setChecked(props.editDataValue)
        } else {
            setData(props.options[0].value)
        }
    }, [props.inputData])

    return (
        <div className={`w-[100px] h-[38px] ${checked ? "bg-[#9cc8ca]" : "bg-gray-400"} transition-colors duration-500 rounded-full flex items-center cursor-pointer relative overflow-hidden`} onClick={props.item.disabled ? "" : switchClickHandler}>
            <div className={`absolute transition-all duration-500 ${checked ? "right-[4px]" : "right-[-58px] top-[4px]"} flex w-[200px] items-center gap-x-[4px]`}>
                <span className='w-[58px] text-center text-[14px] text-white'>{props.options[1].label}</span>
                <div className={`w-[30px] h-[30px] bg-white rounded-full `}>
                </div>
                <span className='w-[58px] text-center text-[14px] text-white'>{props.options[0].label}</span>
            </div>
        </div>
    )
}

export default Switch
